import React from "react";
import ZCLogo from "~/images/zc-logo.svg";
import { screenBrand } from "~/module/brand/brand";

/**
 * 画面のテナントのロゴを表示する。
 *
 * ロゴの解決点をここ1箇所に集約し、画面の実装が個別に画像を埋め込まないようにする
 * （ブランド分離ガイドライン）。既定テナントは本サービスが持つ画像を用いる。
 */
const BrandLogo: React.FC<{ className?: string }> = ({ className }) => {
  const brand = screenBrand();
  return <img src={brand.logo ?? ZCLogo} alt="" className={className} />;
};

export default BrandLogo;
